;(() => {
  const KEY_PREFIX = 'lastCollection:'
  const EXPIRY_MS = 10 * 1000

  const writeContext = (e) => {
    const target = e.target
    if (!target) return
    const link = target.closest(
      'a[data-product-handle][data-collection-handle]',
    )
    if (!link) return

    const productHandle = link.dataset.productHandle
    const collectionHandle = link.dataset.collectionHandle
    const collectionTitle = link.dataset.collectionTitle
    if (!productHandle || !collectionHandle) return

    const payload = {
      collection: collectionHandle,
      title: collectionTitle,
      expiry: Date.now() + EXPIRY_MS,
    }
    try {
      localStorage.setItem(KEY_PREFIX + productHandle, JSON.stringify(payload))
      // console.debug('[collection-context] set', payload)
    } catch {}
  }

  document.addEventListener('click', writeContext)
  document.addEventListener('auxclick', writeContext)

  document.addEventListener('DOMContentLoaded', () => {
    const body = document.body
    const productHandle = body?.dataset?.productHandle
    if (!productHandle) return

    let payload
    try {
      const raw = localStorage.getItem(KEY_PREFIX + productHandle)
      if (!raw) return
      payload = JSON.parse(raw)
    } catch {
      return
    }

    if (!payload?.expiry || Date.now() > payload.expiry) {
      localStorage.removeItem(KEY_PREFIX + productHandle)
      // console.debug('[collection-context] expired')
      return
    }

    const collectionHandle = payload.collection
    if (collectionHandle) {
      const crumb = document.querySelector('[data-breadcrumb-collection]')
      if (crumb) {
        const title = payload.title
        crumb.textContent = title || collectionHandle.replace(/-/g, ' ')
        crumb.setAttribute('href', `/collections/${collectionHandle}`)
      }
      // console.debug('[collection-context] applied', collectionHandle)
    }

    localStorage.removeItem(KEY_PREFIX + productHandle)
  })
})()
